<script setup>
const { getSettings, getFavicon } = useDatabase()
const { value: sSiteInfo } = useState('site-info')
const { site } = await getSettings()

const favicons = await getFavicon()
// console.log(favicons)

const generateIOSfavicons = () => {
  return favicons
    .filter(item => item.path.match(/favicon\/\d+\.png/)) // pathが正しい形式か確認
    .map(item => {
      const [size] = item.path.match(/\d+/); // 数字を抽出
      return {
        rel: 'apple-touch-icon',
        sizes: `${size}x${size}`,
        href: item.url
      };
    });
}

const getLargestFavicon = () => {
  const defaultFavicon = sSiteInfo?.ファビコン?.value
  const files = favicons.filter(v => v.path)

  if (files?.length) {
    // 最大値を持つオブジェクトを探す
    const file = files.reduce((largest, current) => {
      // pathから数値を抽出
      const largestSize = parseInt(largest.path.match(/\d+/)?.[0] || '0', 10);
      const currentSize = parseInt(current.path.match(/\d+/)?.[0] || '0', 10);

      return currentSize > largestSize ? current : largest;
    });

    return file.url
  } else {
    return defaultFavicon
  }
}

useHead({
  titleTemplate: (titleChunk) => titleChunk ? `${titleChunk} | ${site?.name}` : site?.name || '',
  htmlAttrs: { lang: 'ja' },
  link: [
    { rel: 'icon', type: 'image/x-icon', href: getLargestFavicon() },
    ...generateIOSfavicons()
  ],
  meta: [{ name: 'description', content: site?.description }],
})
</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
